import { createContext, use } from "react";
import { defined } from "../utilities/typeHelper";

interface IntercomContextType {
  isIntercomWidgetLoaded: boolean;
  getArticleUrl: (articleId: string) => string;
  showArticle: (articleId: string) => void;
  showNewMessage: (message?: string) => void;
  addEffect: (effect: "opacity" | "hide") => void;
  removeEffect: (effect: "opacity" | "hide") => void;
}

export const IntercomContext = createContext<IntercomContextType | undefined>(undefined);

export const useIntercomContext = () => {
  const context = use(IntercomContext);
  return defined(context);
};
